import { Injectable } from '@angular/core';
import { User } from '../models/user.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CasherService {

  users: User[] = [];
  private cashier = new BehaviorSubject(null);
  cashier$ = this.cashier.asObservable();
  private manager = new BehaviorSubject(null);
  manager$ = this.manager.asObservable();
  private cashierPeriod = new BehaviorSubject(null);
  cashierPeriod$ = this.cashierPeriod.asObservable();
  private downloadCashList = new BehaviorSubject(null);
  downloadCashList$ = this.downloadCashList.asObservable();
  private supervisor = new BehaviorSubject(null);
  supervisor$ = this.supervisor.asObservable();

  constructor(
    private http: HttpClient
  ) { }

  get getCashier() {
    return this.cashier.value;
  }

  setCashier(cashier) {
    this.cashier.next(cashier);
  }

  get getManager() {
    return this.manager.value;
  }

  setManager(manager) {
    this.manager.next(manager);
  }

  get getCashierPeriod() {
    return this.cashierPeriod.value;
  }

  setCashierPeriod(cashierPeriod) {
    this.cashierPeriod.next(cashierPeriod);
  }

  get getDownloadCashList() {
    return this.cashierPeriod.value;
  }

  setDownloadCashList(downloadCashList) {
    this.downloadCashList.next(downloadCashList);
  }

  setSupervisor(supervisor) {
    this.supervisor.next(supervisor);
  }

  get getSupervisor() {
    return this.supervisor.value;
  }

  getAllCasher() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/pos-cashiers`, httpOptions);
  }

  getCasherById(cashierId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/pos-cashiers/${cashierId}`, httpOptions);
  }

  getCasherByEnabled() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/pos-cashiers?&isEnabled=true`, httpOptions);
  }

  getCasherByStore(storeId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/pos-cashiers?storeId=${storeId}`, httpOptions);
  }

  getCasherByName(name) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/pos-cashiers/name/${name}`, httpOptions);
  }

  createCasher(casher) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.post<any>(`${environment.url_api}/pos-cashiers`, casher, httpOptions);
  }

  createCasherSeller(casher) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.post<any>(`${environment.url_api}/pos-cashiers/sellers`, casher, httpOptions);
  }

  editCasher(id: number, casher) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.patch(`${environment.url_api}/pos-cashiers/${id}`, casher, httpOptions);
  }

  findCashierCreate(filter) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/pos-cashiers${filter}`, httpOptions);
  }

}
